<template>
  <div class="calendar-app__timezone">
    <label class="calendar-app__timezone-label"  for="calendar-timezone-select">Time zone:</label>
    <div class="calendar-app__timezone-select-wrapper">
      <select @change="updateTimeZone"  v-model="selectedTimeZone" class="calendar-app__timezone-select" id="calendar-timezone-select">
        <option v-for="timeZone in timeZones" :value="timeZone.value" class="calendar-app__timezone-name">{{timeZone.name}}</option>
      </select>
    </div>
  </div>
</template>
<script>

const searchSettings = window.drupalSettings.searchSettings

import moment from "moment";

export default {
  name: 'CalendarTimeZoneSelector',
  data: function() {
    return {
      timeZones: [
        {name: moment.tz('US/Central').zoneAbbr(), value: 'US/Central'},
        {name: moment.tz('US/Eastern').zoneAbbr(), value: 'US/Eastern'},
        {name: moment.tz('US/Mountain').zoneAbbr(), value: 'US/Mountain'},
        {name: moment.tz('US/Pacific').zoneAbbr(), value: 'US/Pacific'},
        {name: moment.tz('US/Alaska').zoneAbbr() + ' (Alaska)', value: 'US/Alaska'},
        {name: moment.tz('US/Hawaii').zoneAbbr() + ' (Hawaii)', value: 'US/Hawaii'}, // does not observe daylight savings time
      ],
      selectedTimeZone: searchSettings[this.$route.name].default_timezone || 'US/Eastern'
    }
  },
  methods: {
    updateTimeZone()  {
      this.$emit('newTimeZoneSelected', this.selectedTimeZone);
    },
  }
}
</script>
